import {
  Briefcase,
  FileText,
  Languages,
  List,
  Maximize2,
  Minimize2,
  Pencil,
  Search,
  SpellCheck,
  type LucideIcon,
} from 'lucide-react';
import { uboTheme } from '@/theme/uboTheme';

export type AnyEditor = any;

export const UBO_PRIMARY = uboTheme.colors.primary;
export const UBO_SECONDARY = uboTheme.colors.secondary;

export const AUTO_APPLY_ACTIONS = new Set([
  'rewrite',
  'translate',
  'spellcheck',
  'formal',
  'expand',
  'shorten',
  'bullet_points',
]);

export interface ToolCall {
  name: string;
  input: Record<string, any>;
  /** Sleutel naar het resultaat in de toolResults-map (gezet na uitvoeren). */
  _resultKey?: string;
}

export interface Suggestion {
  page?: number;
  issue: string;
  suggestion: string;
  priority: 'hoog' | 'middel' | 'laag';
}

export interface DocEdit {
  type: 'edit' | 'delete' | 'move' | 'create';
  page: number;
  status: 'in_progress' | 'done' | 'error';
  editMode?: string;
  newPosition?: number;
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  action?: string;
  selectedText?: string;
  targetPageIndex?: number;
  hadSelection?: boolean;
  applied?: boolean;
  selectionFrom?: number;
  selectionTo?: number;
  thinking?: string;
  toolCalls?: ToolCall[];
  docEdits?: DocEdit[];
}

export type ChatMode = 'ask' | 'agent';

export const QUICK_ACTIONS: readonly { id: string; label: string; Icon: LucideIcon }[] = [
  { id: 'rewrite', label: 'Herschrijf', Icon: Pencil },
  { id: 'translate', label: 'Vertaal', Icon: Languages },
  { id: 'spellcheck', label: 'Spelling', Icon: SpellCheck },
  { id: 'formal', label: 'Formeler', Icon: Briefcase },
  { id: 'expand', label: 'Uitbreiden', Icon: Maximize2 },
  { id: 'shorten', label: 'Inkorten', Icon: Minimize2 },
  { id: 'bullet_points', label: 'Opsomming', Icon: List },
  { id: 'summarize', label: 'Samenvatten', Icon: FileText },
  { id: 'analyze', label: 'Analyseer', Icon: Search },
];

export const STREAMING_LABELS: Record<string, string> = {
  rewrite: 'Tekst herschrijven',
  translate: 'Vertalen',
  spellcheck: 'Spelling controleren',
  formal: 'Tekst formeler maken',
  expand: 'Tekst uitbreiden',
  shorten: 'Tekst inkorten',
  bullet_points: 'Opsomming maken',
  summarize: 'Samenvatten',
  analyze: 'Document analyseren',
};

/** Standaardopdracht bij overschakelen naar Agent (gebruiker hoeft niet eerst "ga door" te typen). */
export const AGENT_BOOTSTRAP_PROMPT =
  'Scan de offerte en begin direct met de meest effectieve verbetering die je zonder verdere vragen kunt uitvoeren.';

export const PRIORITY_CLASSES: Record<string, string> = {
  hoog: 'bg-red-100 text-red-700',
  middel: 'bg-amber-100 text-amber-700',
  laag: 'bg-blue-100 text-blue-700',
};

export const PAGE_TYPE_LABELS: Record<string, string> = {
  COVER: 'Coverpagina',
  CONTENT_PAGE: 'Contentpagina',
  TEAM: 'Teampagina',
  INVESTMENT: 'Investeringsoverzicht',
  PLAN_VAN_AANPAK: 'Plan van Aanpak',
  SIGNATURE_PAGE: 'Handtekeningpagina',
  FOOTER: 'Sluiting',
};
